export default __webpack_public_path__ + "images/ch-7a52ef5e31b7f5e08a015cbcdc72e365.svg";